import React from 'react'

const WebhookChannelSelection = ({ isWebhookChannelSelected, handleChannelSelection }) => {
  const handleClick = () => {
    handleChannelSelection(isWebhookChannelSelected)
  }

  return (
    <div className='space-y-2'>
      <button
        type='button'
        onClick={handleClick}
        className={`flex w-full items-center justify-between rounded-xs border px-3 py-2 text-left transition-colors duration-200
          ${
            isWebhookChannelSelected
              ? 'border-[var(--color-primary-light)] bg-[var(--color-blue-100)]'
              : 'border-[var(--color-primary-light)] bg-white hover:bg-gray-50'
          }
        `}
        aria-pressed={isWebhookChannelSelected}
        aria-label='Select webhook URL channel'
      >
        <span className='text-sm font-medium'>Webhook URL Channel</span>

        {/* Selection Indicator */}
        <div
          className={`
            h-6 w-6 rounded-full flex items-center justify-center border transition-all duration-200
            ${isWebhookChannelSelected ? 'bg-blue-600 border-blue-600' : 'border-gray-400 bg-white'}
          `}
          aria-hidden='true'
        >
          {isWebhookChannelSelected && (
            <svg className='w-3 h-3 text-white' viewBox='0 0 12 12' fill='none' aria-hidden='true'>
              <path
                d='M10 3L4.5 8.5L2 6'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          )}
        </div>
      </button>
    </div>
  )
}

export { WebhookChannelSelection }
